import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import './css/navigation.css'
import { AiOutlineMenu } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";
import { Offcanvas } from 'react-bootstrap';



const navLinks = [
    {
        title: '_home',
        path: '/'
    },
    {
        title: '_about-me',
        path: '/about-me'
    },
    {
        title: '_projects',
        path: '/projects'
    },
]



export default function Navigation(){

    const location = useLocation()
    const navigate = useNavigate()

    const navigateTo = (path) => navigate(path)
    const goHome = () => navigateTo('/')
    const goToAboutMe = () => navigateTo('/about-me')
    const goToProjects = () => navigateTo('/projects')
    const goToWhatsApp = () => window.open("https://wa.me/message/2G4QW4T3HSL5H1", "_blank")

    const [activeNav, setActiveNav] = useState('/')
    const [showOffCanvasNav, setShowOffCanvasNav] = useState()

    useEffect(() => {
        if(location.pathname.includes('about-me')){
            setActiveNav('/about-me')

        } else if(location.pathname.includes('projects')){
            setActiveNav('/projects')

        } else{
            setActiveNav('/')
        }

    }, [location.pathname])

    const onShowOffCanvasNav = () => setShowOffCanvasNav(true)
    const onHideOffCanvasNav = () => setShowOffCanvasNav(false)

    const displayNavLinks = navLinks.map((link, i) => {
        const { title, path } = link

        const isActive = path == activeNav ? true : false

        const goToPath = () => navigateTo(path)

        return (
            <div
                key={i}
                onClick={goToPath}
                className={
                    `
                        ${
                            i == 0
                            ?
                                'nav-link-txt-container'
                            :

                                'nav-link-container-border-right'
                        }
                        ${
                            isActive && 'nav-link-container-active'
                        }
                        d-lg-block d-md-block d-none
                    `
                }
            >
                <p
                    className={`p-0 nav-link-txt py-3 px-4 m-0 regular-txt txt-607B96 ${isActive && 'text-white'}`}
                >
                        {title}
                </p>
            </div>
        )
    })

    return (
        <div className='nav-container px-3'>
            <div className='d-flex align-items-center justify-content-between'>
                <div className='py-3 col-lg-2'>
                    <p className='m-0 p-0 regular-txt txt-607B96'>cryptokingxavier</p>
                </div>
                <div className='col-lg-7 d-lg-flex d-md-flex d-none justify-content-start'>
                    { displayNavLinks }
                </div>
                <div className='d-lg-flex d-md-flex d-none align-items-center justify-content-end col-lg-2'>
                    <p className={`p-0 py-3 px-4 m-0 pointer regular-txt border-left-light-1E2D3D txt-607B96 nav-link-txt ${activeNav == '/contact-me' && 'text-white'}`} onClick={goToWhatsApp}>_contact-me</p>
                </div>
                <div className='d-lg-none d-md-none d-block'>
                    <AiOutlineMenu size={23} color='#607B96' onClick={onShowOffCanvasNav} />
                </div>
            </div>

            <Offcanvas show={showOffCanvasNav} onHide={onHideOffCanvasNav}>
                <div className='home-bg'>
                    <div className='nav-container px-3'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <p className='py-3 m-0 p-0 regular-txt txt-607B96'>cryptokingxavier</p>
                            <RxCross2 size={23} color='#607B96' onClick={onHideOffCanvasNav} />
                        </div>
                    </div>
                    <div className=''>
                        <p onClick={goHome} className={`p-0 py-3 border-bottom-light-1E2D3D px-3 m-0 regular-txt txt-607B96 nav-link-txt ${activeNav == '/' && 'text-white'}`}>_hello</p>
                        <p onClick={goToAboutMe} className={`p-0 py-3 border-bottom-light-1E2D3D px-3 m-0 regular-txt txt-607B96 nav-link-txt ${activeNav == '/about-me' && 'text-white'}`}>_about-me</p>
                        <p onClick={goToProjects} className={`p-0 py-3 border-bottom-light-1E2D3D px-3 m-0 regular-txt txt-607B96 nav-link-txt ${activeNav == '/projects' && 'text-white'}`}>_projects</p>
                        <p className={`p-0 py-3 border-bottom-light-1E2D3D px-3 m-0 regular-txt txt-607B96 nav-link-txt ${activeNav == '/contact-me' && 'text-white'}`} onClick={goToWhatsApp}>_contact-me</p>
                    </div>
                </div>
            </Offcanvas>
        </div>
    )
}
